import { useState } from 'react'
import { useRFINotificationsContext } from '../../../../../../RFINotificationsContext'
import {
  ByResponseDisciplinesFormItemProps,
  ByResponseDisciplinesFormItemValue,
} from './types'
import CIMSCollapse from '../../../../../../../../../../../../../components/CIMSCollapse'
import { alphabeticalSort } from 'shared'
import { Space } from 'antd'
import CIMSFormItem from '../../../../../../../../../../../../../components/CIMSFormItem'
import RecipientsSelect from '../../../../../../../../../../../../../components/CIMSSelect/common/RecipientsSelect'
import { LabeledValueType } from '../../../../../../../../../../../../../components/CIMSSelect/types'
import GroupFallback from '../../../../../../components/GroupFallback'
import { useCIMSNotificationsPanelContext } from '../../../../../../../../../../../../../components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import ResponderTags from '../../../../../../components/ResponderTags'

const ByResponseDisciplinesFormItem: React.FC<
  ByResponseDisciplinesFormItemProps
> = ({ value, onChange }) => {
  const { event } = useCIMSNotificationsPanelContext()
  const { project, responderEvents } = useRFINotificationsContext()
  const [values, setValues] = useState<
    Map<string, ByResponseDisciplinesFormItemValue>
  >(
    (value ?? []).reduce(
      (map, v) => map.set(v.responseDisciplineId, v),
      new Map<string, ByResponseDisciplinesFormItemValue>()
    )
  )

  return (
    <CIMSCollapse
      noPanelsContent={<GroupFallback />}
      panels={(project?.rfiResponseDisciplines ?? [])
        .sort(alphabeticalSort('name'))
        .map(({ id, name, description }) => ({
          key: id,
          header: {
            type: 'described',
            name,
            description,
          },
          children: (
            <Space size="large" direction="vertical" style={{ width: '100%' }}>
              {responderEvents.some(
                (responderEvent) => responderEvent.id === event.id
              ) && <ResponderTags responseDiscipline={{ id, name }} />}
              <CIMSFormItem label="Recipients">
                <RecipientsSelect
                  multiple
                  value={values.get(id.toString())?.recipients ?? []}
                  onChange={(value) => {
                    const recipients = value as LabeledValueType[]
                    setValues((prev) => {
                      const map = new Map(prev)
                      map.set(id.toString(), {
                        responseDisciplineId: id.toString(),
                        recipients,
                      })
                      onChange?.([...map.values()])
                      return map
                    })
                  }}
                />
              </CIMSFormItem>
            </Space>
          ),
        }))}
    />
  )
}

export default ByResponseDisciplinesFormItem
